(function(){
 'use strict';
 var dialog=document.getElementById('ld-news-dialog');if(!dialog||typeof dialog.showModal!=='function')return;
 var storageKey='ld-news-invitation-v1',start=Date.now(), engaged=false, shown=false,lastFocus=null;
 function recentlyShown(){try{return Date.now()-Number(localStorage.getItem(storageKey)||0)<7*86400000;}catch(e){return false;}}
 function remember(){try{localStorage.setItem(storageKey,String(Date.now()));}catch(e){}}
 function busy(){var p=document.getElementById('ld-cookie-panel');if(p&&!p.hidden)return true;if(document.querySelector('dialog[open],.modal.in,.modal.show,.global-quick-buy-modal.is-open,.ld-sticky-cart-drawer.is-open'))return true;var el=document.activeElement;return !!(el&&el.matches('input,textarea,select'));}
 function show(){if(shown||!engaged||Date.now()-start<30000||recentlyShown()||busy()||document.hidden)return;shown=true;remember();lastFocus=document.activeElement;dialog.showModal();}
 function checkEngagement(){var height=document.documentElement.scrollHeight-innerHeight;if(height>0&&scrollY/height>=.35)engaged=true;}
 window.addEventListener('scroll',checkEngagement,{passive:true});
 document.addEventListener('mouseout',function(e){if(matchMedia('(hover:hover) and (pointer:fine)').matches&&e.clientY<=0&&!e.relatedTarget)show();});
 setTimeout(function(){checkEngagement();if(matchMedia('(hover:none), (pointer:coarse)').matches)show();},45000);
 function close(){dialog.close();}
 dialog.querySelectorAll('[data-ld-news-close]').forEach(function(b){b.addEventListener('click',close);});
 dialog.addEventListener('close',function(){if(lastFocus&&lastFocus.isConnected)lastFocus.focus();});
 dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
 dialog.querySelector('[data-ld-news-join]').addEventListener('click',remember);
})();

/* Refresh the existing collection in Shopify's best-selling order. */
(function(){
 'use strict';
 var host=document.getElementById('ld-home-favourites');if(!host)return;
 function syncLanguage(){
  var cookie=document.cookie.match(/(?:^|;\s*)sn-multiling=(lang[12])(?:;|$)/);
  var language=cookie?cookie[1]:(window._bilingualTheme&&window._bilingualTheme.settings.primary_language==='2'?'lang2':'lang1');
  host.querySelectorAll('.lang').forEach(function(el){el.style.display=el.classList.contains(language)?(el.classList.contains('inline-block')?'inline-block':'block'):'none';});
 }
 document.addEventListener('ld:language-change',syncLanguage);
 var controller=new AbortController();var timeout=setTimeout(function(){controller.abort();},8000);
 fetch(host.dataset.ldFavouritesUrl,{credentials:'same-origin',signal:controller.signal})
 .then(function(response){if(!response.ok)throw new Error('Collection unavailable');return response.text();})
 .then(function(html){
  var parsed=new DOMParser().parseFromString(html,'text/html');var grid=parsed.querySelector('.ld-product-grid');
  if(!grid||!grid.querySelector('.ld-product-card'))return;
  // Keep the initial cards if a customer has already opened their quick-buy dialog.
  if(document.querySelector('.global-quick-buy-modal.is-open'))return;
  host.replaceChildren(grid);syncLanguage();
 }).catch(function(){/* The server-rendered collection remains available. */})
 .finally(function(){clearTimeout(timeout);});
})();
